import netWorkController from "@/http/netWorkController";
import toastUtils from "@/utils/toastUtils";
import IcpFooter from "@/views/IcpFooter.vue";

export default {
    name: "loginPage",
    components: {IcpFooter},
    data() {
        return {
            userInfo: {},
        }
    },
    created() {
    },
    mounted() {
    },
    methods: {
        logIn() {
            if (!this.userInfo.userName || !this.userInfo.userName) {
                toastUtils.warning(this, "用户名和密码不能为空!")
                return;
            }
            netWorkController.logIn(this.userInfo.userName, this.userInfo.passWord, (result) => {
                if (result.status === 200) {
                    toastUtils.success(this, "登陆成功")
                    //存储对象，转成Json存入
                    window.localStorage.setItem("userInfo", JSON.stringify(result.data))
                    window.replace(this, "/appListPage")
                } else {
                    toastUtils.warning(this, result.msg)
                }
            })
        },
    }


}